// extracted by mini-css-extract-plugin
export var listPaginationMobileButton = "hooks-module--listPaginationMobileButton--c07b1";